// import socketIOClient from "socket.io-client";
// import { SOCKET_ROOT as ENDPOINT } from '../configs/api';
// const socket = socketIOClient(ENDPOINT);


export function setHomeData(data) {
    return function (dispatch) {
        dispatch({ type: "SET_HOME_DATA", homeData: data });
    };
}